<script setup lang="ts">
interface Props {
  /** When true the icon spins and clicking is a no-op. */
  readonly loading?: boolean;
  /** Tooltip / aria-label. */
  readonly label?: string;
}
withDefaults(defineProps<Props>(), {
  loading: false,
  label: '刷新',
});

defineEmits<{
  (event: 'click'): void;
}>();
</script>

<template>
  <button
    type="button"
    class="btn btn--icon btn--ghost refresh-button"
    :disabled="loading"
    :aria-label="label"
    :title="label"
    data-testid="refresh-button"
    @click="$emit('click')"
  >
    <span
      v-if="loading"
      class="spinner"
      aria-hidden="true"
    ></span>
    <svg
      v-else
      class="refresh-button__icon"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <path d="M3 12a9 9 0 0 1 15-6.7L21 8" />
      <path d="M21 3v5h-5" />
      <path d="M21 12a9 9 0 0 1-15 6.7L3 16" />
      <path d="M3 21v-5h5" />
    </svg>
    <span class="sr-only">{{ label }}</span>
  </button>
</template>

<style scoped>
.refresh-button__icon {
  display: block;
}
</style>
